import { render, staticRenderFns } from "./PaymentsStore.vue?vue&type=template&id=f6a997f2"
import script from "./PaymentsStore.vue?vue&type=script&lang=js"
export * from "./PaymentsStore.vue?vue&type=script&lang=js"
import style0 from "./PaymentsStore.vue?vue&type=style&index=0&id=f6a997f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports